

import { faCar, faRoad, faScroll, faStar, faTrashCan, faTriangleExclamation, faTruck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import useNotification from "../notifications/useNotifications";
import { useForm } from "react-hook-form";
import EngineIcon from "../../assets/svgs/engine.svg";
import { IVehicle } from "../../models/Vehicle";
import { useEffect } from "react";


interface FormValues {
  accessIssues: boolean;
  vehicleComplete: boolean;
  freeOfWaste: boolean;
  vehicleStarting: boolean;
  vehiclePremium: boolean;
  isVan: boolean;
  hasAlert: boolean;
  codRequired: boolean;
}

export default function VehicleCollectionQuestions({ vehicle }: { vehicle: IVehicle }) {
  const { t } = useTranslation("vehicles");
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers(t("Vehicle details"));
  const { addNotification } = useNotification();
  const { register, getValues, setValue, watch, handleSubmit, reset, control } = useForm<FormValues>({
    defaultValues: {
      accessIssues: vehicle.accessIssues,
      vehicleComplete: vehicle.vehicleComplete,
      freeOfWaste: vehicle.freeOfWaste,
      vehicleStarting: vehicle.vehicleStarting,
      vehiclePremium: vehicle.vehiclePremium,
      isVan: vehicle.isVan,
      hasAlert: vehicle.hasAlert,
      codRequired: vehicle.codRequired,
    },
  });

  useEffect(() => {
    const currentCodRequired = watch("codRequired");

    if (vehicle.codRequired !== currentCodRequired) {
      setValue("codRequired", vehicle.codRequired);
    }

  }, [vehicle.codRequired, reset]);


  const onSubmit = (data: FormValues) => {
    const updatedVehicle = {
      ...vehicle,
      ...data,
    };

    update.mutate(updatedVehicle, {
      ...saveHandlers,
      onSuccess: () => {
        saveHandlers.onSuccess();
        reset({ ...data });
      },
    });
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setValue(name as keyof FormValues, checked);

    handleSubmit(onSubmit)();
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-1 sm:grid-cols-3 [&>div]:flex [&>div]:items-center [&>div]:gap-x-2 [&>div]:mb-2">
        <div>
          <input {...register("isVan")} type="checkbox" onChange={handleCheckboxChange} />
          <FontAwesomeIcon icon={faTruck} />
          <label>{t("Van")}</label>
        </div>
        <div>
          <input {...register("hasAlert")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <label>{t("Alert")}</label>
        </div>
        <div>
          <input {...register("vehiclePremium")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faStar} className="text-yellow-600" />
          <label>{t("Premium vehicle")}</label>
        </div>

        <div>
          <input {...register("accessIssues")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faRoad} />
          <label>{t("Access issues")}</label>
        </div>
        <div>
          <input {...register("vehicleComplete")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faCar} />
          <label>{t("Vehicle complete")}</label>
        </div>
        <div>
          <input {...register("codRequired")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faScroll} />
          <label>{t("COD Required")}</label>
        </div>

        <div>
          <input {...register("freeOfWaste")} onChange={handleCheckboxChange} type="checkbox" />
          <FontAwesomeIcon icon={faTrashCan} />
          <label>{t("Vehicle free of waste")}</label>
        </div>
        <div>
          <input {...register("vehicleStarting")} onChange={handleCheckboxChange} type="checkbox" />
          <img src={EngineIcon} className="h-5 w-5" />
          <label>{t("Vehicle starting")}</label>
        </div>

      </div>

    </form>
  );
}